module.exports = __webpack_public_path__ + "static/media/drilldown_close.d212a356.svg";